<template>

</template>

<script>
    export default {
        name: "industryDetail"
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ganPinMonitoring/industryDetail.vue